import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { CustomJs } from './custom-js/CustomJs';
import { CUSTOM_JS } from 'drapcode-constant';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class CustomJsTab extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    fullScreen: false,
    cssFullScreen: false,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
  }
  toggleFullscreen = () => {
    this.setState((prevState) => ({
      fullScreen: !prevState.fullScreen,
    }));
  };
  render() {
    const fullScreenCss = {
      position: 'relative',
      top: '-119px',
      left: '-15px',
      width: '97vw',
    };
    const { fullScreen } = this.state;
    const { appSetting, actions, permission, match } = this.props;
    const {
      projectDetail,
      permissionFlags,
      addProjectCustomJsCdnPending,
      addProjectCustomJsPending,
    } = appSetting;
    if (!projectDetail) {
      return '';
    }
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { projectId, version } = match.params;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'customJS'} projectDetail={projectDetail} />
        <div style={fullScreen ? fullScreenCss : {}}>
          <CustomJs
            projectId={projectId}
            projectDetail={projectDetail}
            actions={actions}
            version={version}
            showCustomJSCDNLoader={addProjectCustomJsCdnPending}
            showCustomJSLoader={addProjectCustomJsPending}
            appSetting={appSetting}
            toggleFullscreen={this.toggleFullscreen}
            togglestate={this.state.fullScreen}
            deleteFlag={permissionsArray.includes(CUSTOM_JS)}
            isReadOnly={isReadOnly}
          />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomJsTab);
